import React from 'react';
import Editor from './editor/Editor';
import {Landing} from './landing/Landing';
import ReactDOM from 'react-dom/client';
import './index.css';
import SignUp from './SignUp';
import Login from './Login';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {Init} from "./init";
import JustFuckingDance from "./JustFuckingDance";
import {Notify} from "./Notify";
import {Tile} from "./Tile";
import {Curate as AllegedlyTrueCurate} from "./games/allegedly_true/curate";
import {PlaybackPrototype} from "./games/dancelestrations/playback_prototype";
import {SpeechLoop} from "./games/ai/speech_loop";
import {VoiceTest} from "./games/voice/voice_test";
import {JoinPage} from "./games/character_creator/character_ready";
import {DemoGame, DemoPreview, SellHost} from "./games/demo/demo";
import {installSamples} from "./preview/samples";

// Resolve the active session token at every fetch. Priority order:
//   1. ?token= URL param on the document — wins over cookie. Required for
//      the /tile multi-iframe view where the parent has its own cookie
//      (operator/control) but each iframe needs to act as a different
//      player. Captured ONCE per document (not per fetch) since the URL
//      doesn't change after load.
//   2. user_token cookie — the normal logged-in case.
//   3. localStorage backup — only kicks in when both URL and cookie are
//      absent (e.g. iOS Safari wiped cookies on memory pressure).
// We re-read cookie/localStorage on EVERY fetch so a fresh login (which
// sets a new cookie + updates localStorage) is picked up immediately.
const initialUrlToken = new URLSearchParams(window.location.search).get('token');
if (initialUrlToken) {
    try { localStorage.setItem('jfd_token', initialUrlToken); } catch (e) {}
}

const inIframe = (() => { try { return window.self !== window.top; } catch (e) { return true; } })();

const resolveFallbackToken = () => {
    // Inside iframes (the /tile multi-player view), the URL ?token=
    // wins over cookie because all iframes share the parent's cookie
    // and we need each iframe to act as a different player.
    if (inIframe && initialUrlToken) return initialUrlToken;
    const cookieToken = (document.cookie.match(/(?:^|;\s*)user_token=([^;]+)/) || [])[1];
    if (cookieToken) return null; // cookie is fine; let the browser send it
    try {
        return localStorage.getItem('jfd_token') || null;
    } catch (e) {
        return null;
    }
};

const origFetch = window.fetch.bind(window);
const withToken = (url, token) => {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}token=${encodeURIComponent(token)}`;
};
window.fetch = (input, init) => {
    const token = resolveFallbackToken();
    if (!token) return origFetch(input, init);
    // Never clobber an explicit token param (e.g. ?token=boss) with the
    // auth fallback — repeated params resolve last-wins on the server.
    const hasToken = (url) => /[?&]token=/.test(url);
    if (typeof input === 'string') return origFetch(hasToken(input) ? input : withToken(input, token), init);
    if (input instanceof Request) return origFetch(hasToken(input.url) ? input : new Request(withToken(input.url, token), input), init);
    return origFetch(input, init);
};

// The marketing site; show servers (play.imgoingto.party, localhost) render the game at the root.
const LANDING_HOSTS = ['imgoingto.party', 'www.imgoingto.party'];

installSamples();

const root = ReactDOM.createRoot(
    document.getElementById('root')
);

root.render(
    <BrowserRouter>
        <Switch>
            <Route path="/editor"><Editor/></Route>
            <Route path="/init"><Init/></Route>
            <Route path="/login"><Login/></Route>
            <Route path="/register"><SignUp/></Route>
            <Route path="/notify"><Notify/></Route>
            <Route path="/tile"><Tile/></Route>
            <Route path="/allegedly-true-curate"><AllegedlyTrueCurate/></Route>
            <Route path="/playback-prototype"><PlaybackPrototype/></Route>
            <Route path="/speech-loop"><SpeechLoop/></Route>
            <Route path="/voice-test"><VoiceTest/></Route>
            <Route path="/join"><JoinPage/></Route>
            <Route path="/sell"><SellHost/></Route>
            <Route path="/demo/:code"><DemoGame/></Route>
            <Route path="/demo-preview/:screen"><DemoPreview/></Route>
            <Route path="/landing"><Landing/></Route>
            <Route path="/">{LANDING_HOSTS.includes(window.location.hostname) ? <Landing/> : <JustFuckingDance/>}</Route>
        </Switch>
    </BrowserRouter>
);
